import  { useState } from "react";
import classNames from "classnames";

import { PillInputBox } from "../../components/forms/form-inputs";
import { AppSwitch } from "../../components/utilities/switcher";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { useAuth } from "../../services/authentication/authentication.context";
import { LoadingIndicator } from "../../components/utilities/loader";
import { AppAlert } from "../../components/utilities/app-alert";

export const SigninPage = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [switched, setSwitched] = useState(false);
    const [onAlert, setOnAlert] = useState();

    const { userSignin, isLoading } = useAuth();

    const handleSubmit = async(e) => {
        e.preventDefault();
        const resp = await userSignin({email, password});
        if (resp?.error) {
            setOnAlert({
                message: resp?.error,
                caption: "Error!",
                accept: "Ok",
                action: () => setOnAlert()
            })
        }else{
            setEmail();
            setPassword();
        }
    }

    return (
        <div className={classNames("flx-cnt-pg", "full-v")}>
            {isLoading && <LoadingIndicator />}
            {onAlert &&
            <AppAlert 
                caption={onAlert.caption}
                message={onAlert.message}
                accept={onAlert.accept}
                onAccept={onAlert.action}
                closeAlert={() => setOnAlert()}
            />
            }
            <div className={classNames("cap","lg-txt")}>Welcome back</div>
            <div className="sm-sp" />
            <div className={classNames("cap","lg-txt")}>Sign in</div>
            <div className="md-sp" />
            <form className="sign-in" onSubmit={handleSubmit}>
                <PillInputBox
                    type={"email"}
                    name={"email"}
                    caption={"Email"}
                    placeholder={"e.g mymail@provider.com"}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <PillInputBox
                    type={switched ? "text" : "password"}
                    caption={"Password"}
                    placeholder={"Enter your password"}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <div className="alt-actions">
                    <a href="/resetemail">Forgot my password</a>
                </div>
                <div className="flx-c-rw">
                    <AppSwitch
                        switchedIcon={faEye}
                        unswitchedIcon={faEyeSlash}
                        switchedColor={"#340634"}
                        unswitchedColor={"#dedede"}
                        onSwitch={() => setSwitched((v) => !v)}
                    />
                    <div className={classNames("cap","sm-txt")}>
                        {switched ? "Hide password" : "Show password"}
                    </div>
                </div>
                
                <button 
                    className={classNames("form-button",'pill-input-box')}
                >
                    Submit
                </button>
                <div className="alt-actions">
                    Don't yet have an account?{" "} 
                    <a href="/signup">Create an account</a>
                </div>
            </form>
        </div>
    )
}